import { render, staticRenderFns } from "./PersonComponent.vue?vue&type=template&id=35142bd8"
import script from "./PersonComponent.vue?vue&type=script&lang=js"
export * from "./PersonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports